import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import router from './router'
import VueFractionGrid from "vue-fraction-grid"
import VueResource from 'vue-resource'
import store from './store'
import { sync } from 'vuex-router-sync'

import './assets/css/style.scss'
import 'mapbox-gl/dist/mapbox-gl.css'
import './directives/click-outside'
import 'grapesjs/dist/css/grapes.min.css'

Vue.use(VueRouter)
Vue.use(VueFractionGrid)
Vue.use(VueResource)

sync(store, router)

import apiConfig from './config/apiConfig'
Vue.http.options.root = apiConfig.url

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
